/**
 * Polling constants shared between useBulkJobs and useAsyncExports.
 * Single source of truth — do NOT duplicate these values elsewhere.
 */

/** Initial poll interval in milliseconds. */
export const INITIAL_POLL_INTERVAL = 5000; // 5 seconds

/** Maximum poll interval in milliseconds. */
export const MAX_POLL_INTERVAL = 30000; // 30 seconds

/** Maximum number of poll retries (5 minutes total at initial interval). */
export const MAX_RETRIES = 60;

/**
 * Poll interval in ms when there are active (in-flight) bulk jobs.
 * Faster cadence to keep the badge and drawer responsive during operations.
 */
export const ACTIVE_POLL_MS = 3000; // 3 seconds

/**
 * Poll interval in ms when there are no active bulk jobs.
 * Slower cadence reduces unnecessary API traffic during idle periods.
 */
export const IDLE_POLL_MS = 10000; // 10 seconds

/**
 * Maximum wall-clock time to poll a single bulk job before the hook
 * marks it as failed and stops polling. Aligned with the backend's
 * 10-minute resolver timeout (resolve.go). Uses wall-clock rather
 * than attempt count so idle/active polling interval switches don't
 * change the ceiling.
 */
export const MAX_BULK_POLL_WALLCLOCK_MS = 12 * 60 * 1000; // 12 minutes

/**
 * Jobs that reach a terminal status within this window (ms from client-side
 * submission) are "auto-quieted": the badge count is never incremented,
 * preventing flicker for fast bulk operations (e.g. 2-row tag = ~400ms).
 *
 * UX divergence #3 from the design review.
 */
export const AUTO_QUIET_MS = 2000;
